const shippedOrderCols = ['code', 'date', 'withdraw', 'depot', 'numPackages'];

export default shippedOrderCols;
